import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import { withTranslation } from 'react-i18next';
import Store from 'store';
import { isMobile } from 'react-device-detect';

import { Link, Button } from '@material-ui/core';

import { ContentsWrap, Vdivider, RowCenter, Row, MediaQuery } from '../components/Common';

import { PCFooter, MobileFooter, FooterItem, FooterLink, GnbFooterListText } from '../components/Footer';

import images from '../assets';
import { marketingApi } from '../marketing-api';

class Footer extends React.Component {
  constructor() {
    super();
    this.state = {
      addressopen: false,
      aboutusopen: false,
      viewGoTop: false,
    };
    this.handleScrollToElement = this.handleScrollToElement.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScrollToElement, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScrollToElement);
  }

  handleScrollToElement(event) {
    this.setState({ viewGoTop: window.scrollY > 100 });
  }

  onAboutUs = (e) => {
    marketingApi.useClickFnbEffect(e.target.innerText);
    this.setState({ aboutusopen: false });
    this.props.history.push('/aboutus');
  };

  onNoticeList = (e) => {
    marketingApi.useClickFnbEffect(e.target.innerText);
    this.setState({ aboutusopen: false });
    this.props.history.push('/notices');
  };

  onEventList = (e) => {
    marketingApi.useClickFnbEffect(e.target.innerText);
    this.setState({ aboutusopen: false });
    this.props.history.push('/events');
  };

  onWriteReq = (e) => {
    marketingApi.useClickFnbEffect(e.target.innerText);
    this.setState({ aboutusopen: false });
    this.props.history.push('/writereq');
  };

  onCs = () => {
    this.setState({ aboutusopen: false });
    this.props.history.push('/mypage/basic/svccenter');
  };

  onViewTerm = (id) => {
    /*
        1 : "서비스 이용약관"
        2 : "개인정보 처리방침"
        3 : "구매 라이센스"
        4 : "판매 라이센스"
        5 : "JCS 저작권 계약"
         */
    this.setState({ aboutusopen: false });
    this.props.history.push({
      pathname: `/viewterm/${id}`,
    });
  };

  onInstagram = () => {
    marketingApi.useClickFnbEffect('Instagram');
    window.open('https://www.instagram.com/textiledesignbank');
  };

  onFacebook = () => {
    marketingApi.useClickFnbEffect('Facebook');
    window.open('https://www.facebook.com/textiledesignbank');
  };

  onBlog = () => {
    marketingApi.useClickFnbEffect('blog');
    window.open('https://blog.naver.com/tdb_develop');
  };

  onPinterest = () => {
    marketingApi.useClickFnbEffect('Pinterest');
    window.open('https://www.pinterest.co.kr/textiledesignb');
  };

  onLinkedin = () => {
    marketingApi.useClickFnbEffect('Linkedin');
    window.open('https://www.linkedin.com/in/%EC%88%98%EC%9D%80-%EC%8B%A0-8bb736219');
  };

  render() {
    const { t } = this.props;
    const { addressopen, aboutusopen, viewGoTop } = this.state;
    return (
      <ContentsWrap style={{ borderTop: '1px solid #eeeeee' }}>
        <MediaQuery min={920}>
          <PCFooter>
            <Row style={{ alignItems: 'flex-start' }}>
              <img alt="" src={images.top_logo} />
              <RowCenter style={{ flex: 1, justifyContent: 'flex-end' }}>
                <FooterLink onClick={this.onAboutUs}>{t('about_us')}</FooterLink>
                <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                <FooterLink onClick={this.onNoticeList}>{t('notice')}</FooterLink>
                <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                <FooterLink onClick={this.onEventList}>{t('event')}</FooterLink>
                <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                <FooterLink
                  onClick={() => {
                    marketingApi.useClickFnbEffect(t('terms'));
                    this.onViewTerm(1);
                  }}
                >
                  {t('terms')}
                </FooterLink>
                <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                <FooterLink
                  onClick={() => {
                    marketingApi.useClickFnbEffect(t('privacy_policy'));
                    this.onViewTerm(2);
                  }}
                >
                  {t('privacy_policy')}
                </FooterLink>
                <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                <FooterLink
                  onClick={() => {
                    marketingApi.useClickFnbEffect(t('customer_service'));
                    this.onCs();
                  }}
                >
                  {t('customer_service')}
                </FooterLink>
                <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                <FooterLink onClick={this.onWriteReq}>{t('contact_us')}</FooterLink>

                {Store.get('lang') === 'kr' ?
                  <>
                    <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                    <FooterLink onClick={(e) => {
                      marketingApi.useClickFnbEffect(t('career'));
                      this.props.history.push('/employ');
                      e.preventDefault()
                    }}>{t('career')}</FooterLink>
                  </>
                  : <></>}
              </RowCenter>
            </Row>
            <Row style={{ alignItems: 'flex-start' }}>
              <div style={{ flex: 1 }}>
                <RowCenter style={{ paddingTop: 18 }}>
                  <FooterItem>{t('footer_address')}</FooterItem>
                  {Store.get('lang') === 'kr' && (
                    <>
                      <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                      <FooterItem>대표. 신수은 </FooterItem>
                      <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                      <FooterItem> TEL. 02-2135-7736</FooterItem>
                      <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                      <FooterItem>FAX. 02-525-5025 </FooterItem>
                    </>
                  )}
                </RowCenter>
                <RowCenter>
                  {Store.get('lang') === 'kr' ? (
                    <FooterItem>{t('business_num')}:720-88-02717</FooterItem>
                  ) : (
                    <FooterItem>EMAIL:textiledesignbank@gmail.com</FooterItem>
                  )}
                  <Vdivider style={{ paddingLeft: 10, paddingRight: 10 }} />
                  {Store.get('lang') === 'kr' ? (
                    <FooterItem>통신판매업:제 2024-서울강남-05853 호</FooterItem>
                  ) : (
                    <FooterItem>{t('business_num')}:720-88-02717</FooterItem>
                  )}
                </RowCenter>
                <FooterItem style={{ fontSize: 14, paddingTop: 8 }}>
                  Copyright 2023 Textile Design Bank Co. ,Ltd. All rights reserved.
                </FooterItem>
              </div>
              <div>
                <Button size="small" style={{ minWidth: 50 }} onClick={this.onInstagram}>
                  <img alt="" src={images.footer_instagram} />
                </Button>
                <Button size="small" style={{ minWidth: 50 }} onClick={this.onFacebook}>
                  <img alt="" src={images.footer_facebook} />
                </Button>
                <Button size="small" style={{ minWidth: 50 }} onClick={this.onBlog}>
                  <img alt="" src={images.footer_naverblog} />
                </Button>
                <Button size="small" style={{ minWidth: 50 }} onClick={this.onPinterest}>
                  <img alt="" src={images.footer_pinterester} />
                </Button>
                <Button size="small" style={{ minWidth: 50 }} onClick={this.onLinkedin}>
                  <img alt="" src={images.footer_linkedin} />
                </Button>
              </div>
            </Row>
          </PCFooter>
        </MediaQuery>
        <MediaQuery max={919}>
          <MobileFooter style={{ marginTop: '2vw', marginBottom: '5vw' }}>
            <MediaQuery min={700}>
              <div>
                <img alt="" src={images.top_logo} />
              </div>
              <RowCenter style={{ paddingTop: 18 }}>
                <FooterItem>{t('footer_address')}</FooterItem>
                {Store.get('lang') === 'kr' && (
                  <>
                    <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                    <FooterItem>대표. 신수은 </FooterItem>
                    <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                    <FooterItem>TEL. 02-2135-7736</FooterItem>
                    <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                    <FooterItem>FAX. 02-525-5025 </FooterItem>
                  </>
                )}
              </RowCenter>
              <RowCenter style={{ marginTop: 10 }}>
                {Store.get('lang') === 'kr' ? (
                  <FooterItem>{t('business_num')}:720-88-02717</FooterItem>
                ) : (
                  <FooterItem>EMAIL:textiledesignbank@gmail.com</FooterItem>
                )}
                <Vdivider style={{ paddingLeft: 10, paddingRight: 10 }} />
                {Store.get('lang') === 'kr' ? (
                  <FooterItem>통신판매업:제 2024-서울강남-05853 호</FooterItem>
                ) : (
                  <FooterItem>{t('business_num')}:720-88-02717</FooterItem>
                )}
              </RowCenter>
              <RowCenter style={{ marginTop: 10 }}>
                <FooterLink onClick={this.onAboutUs} underline={'none'}>
                  {t('about_us')}
                </FooterLink>
                <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                <FooterLink onClick={this.onNoticeList}>{t('notice')}</FooterLink>
                <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                <FooterLink onClick={this.onEventList}>{t('event')}</FooterLink>
                <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                <FooterLink
                  onClick={() => {
                    marketingApi.useClickFnbEffect(t('terms'));
                    this.onViewTerm(1);
                  }}
                >
                  {t('terms')}
                </FooterLink>
                <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                <FooterLink
                  onClick={() => {
                    marketingApi.useClickFnbEffect(t('privacy_policy'));
                    this.onViewTerm(2);
                  }}
                >
                  {t('privacy_policy')}
                </FooterLink>
                <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                <FooterLink href="#" underline={'none'}>
                  {t('customer_service')}
                </FooterLink>
                <Vdivider style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 3 }} />
                <FooterLink onClick={this.onWriteReq}>{t('contact_us')}</FooterLink>
              </RowCenter>
              <RowCenter style={{ marginTop: 10 }}>
                <Button size="small" style={{ minWidth: 50 }} onClick={this.onInstagram}>
                  <img alt="" src={images.footer_instagram} />
                </Button>
                <Button size="small" style={{ minWidth: 50 }} onClick={this.onFacebook}>
                  <img alt="" src={images.footer_facebook} />
                </Button>
                <Button size="small" style={{ minWidth: 50 }} onClick={this.onBlog}>
                  <img alt="" src={images.footer_naverblog} />
                </Button>
                <Button size="small" style={{ minWidth: 50 }} onClick={this.onPinterest}>
                  <img alt="" src={images.footer_pinterester} />
                </Button>
                <Button size="small" style={{ minWidth: 50 }} onClick={this.onLinkedin}>
                  <img alt="" src={images.footer_linkedin} />
                </Button>
              </RowCenter>

              <div style={{ textAlign: 'center', marginTop: 20 }}>
                <FooterItem style={{ fontSize: 14, paddingTop: 8 }}>
                  Copyright 2023 Textile Design Bank Co. ,Ltd. All rights reserved.
                </FooterItem>
              </div>
            </MediaQuery>
            <MediaQuery max={699}>
              <div>
                <img alt="" src={images.top_logo} style={{ maxWidth: 209, width: '60%', height: 'auto' }} />
              </div>
              <ListItem
                button
                onClick={() => {
                  this.setState({ addressopen: !addressopen });
                }}
              >
                <ListItemText primary={t('company_address')} />
                {addressopen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={addressopen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItem>
                    <GnbFooterListText primary={t('footer_address')} />
                  </ListItem>
                  {Store.get('lang') === 'kr' ? (
                    <>
                      <ListItem>
                        <GnbFooterListText primary="대표. 신수은 " />
                      </ListItem>
                      <ListItem>
                        <GnbFooterListText primary="TEL. 02-2135-7736" />
                      </ListItem>
                      <ListItem>
                        <GnbFooterListText primary="FAX. 02-525-5025 " />
                      </ListItem>
                      <ListItem>
                        <GnbFooterListText primary="사업자번호:720-88-02717" />
                      </ListItem>
                      <ListItem>
                        <GnbFooterListText primary="통신판매업:제 2024-서울강남-05853 호" />
                      </ListItem>
                    </>
                  ) : (
                    <>
                      <ListItem>
                        <GnbFooterListText primary="EMAIL:textiledesignbank@gmail.com" />
                      </ListItem>
                      <ListItem>
                        <GnbFooterListText primary="BUSINESS LICENSE NUMBER:720-88-02717" />
                      </ListItem>
                    </>
                  )}
                </List>
              </Collapse>
              <ListItem
                button
                onClick={() => {
                  this.setState({ aboutusopen: !aboutusopen });
                }}
              >
                <ListItemText primary={t('about_us')} />
                {aboutusopen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={aboutusopen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItem onClick={this.onAboutUs} style={{ cursor: 'pointer' }}>
                    <GnbFooterListText primary={t('about_us')} />
                  </ListItem>
                  <ListItem onClick={this.onNoticeList} style={{ cursor: 'pointer' }}>
                    <GnbFooterListText primary={t('notice')} />
                  </ListItem>
                  <ListItem onClick={this.onEventList} style={{ cursor: 'pointer' }}>
                    <GnbFooterListText primary={t('event')} />
                  </ListItem>
                  <ListItem
                    onClick={() => {
                      marketingApi.useClickFnbEffect(t('terms'));
                      this.onViewTerm(1);
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <GnbFooterListText primary={t('terms')} />
                  </ListItem>
                  <ListItem
                    onClick={() => {
                      marketingApi.useClickFnbEffect(t('privacy_policy'));
                      this.onViewTerm(2);
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <GnbFooterListText primary={t('privacy_policy')} />
                  </ListItem>
                  <ListItem style={{ cursor: 'pointer' }}>
                    <GnbFooterListText primary={t('customer_service')} />
                  </ListItem>
                  <ListItem onClick={this.onWriteReq} style={{ cursor: 'pointer' }}>
                    <GnbFooterListText primary={t('contact_us')} />
                  </ListItem>
                </List>
              </Collapse>
              <RowCenter style={{ marginTop: 10, justifyContent: 'center' }}>
                <Button size="small" style={{ minWidth: 50 }} onClick={this.onInstagram}>
                  <img alt="" src={images.footer_instagram} />
                </Button>
                <Button size="small" style={{ minWidth: 50 }} onClick={this.onFacebook}>
                  <img alt="" src={images.footer_facebook} />
                </Button>
                <Button size="small" style={{ minWidth: 50 }} onClick={this.onBlog}>
                  <img alt="" src={images.footer_naverblog} />
                </Button>
                <Button size="small" style={{ minWidth: 50 }} onClick={this.onPinterest}>
                  <img alt="" src={images.footer_pinterester} />
                </Button>
                <Button size="small" style={{ minWidth: 50 }} onClick={this.onLinkedin}>
                  <img alt="" src={images.footer_linkedin} />
                </Button>
              </RowCenter>
              <div style={{ textAlign: 'center', marginTop: 20 }}>
                <FooterItem style={{ fontSize: 14, paddingTop: 8 }}>
                  Copyright 2023 Textile Design Bank Co. ,Ltd. All rights reserved.
                </FooterItem>
              </div>
            </MediaQuery>
          </MobileFooter>
        </MediaQuery>
        {viewGoTop && (
          <MediaQuery min={700}>
            <Link
              style={{ position: 'fixed', bottom: 100, right: 25, cursor: 'pointer', zIndex: 10 }}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <img
                alt=""
                src={images.footer_totop}
                style={{
                  borderRadius: 6,
                  boxShadow: '0 4px 18px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1)',
                }}
              />
            </Link>
          </MediaQuery>
        )}
        {!isMobile && viewGoTop && (
          <MediaQuery max={699}>
            <Link
              style={{ position: 'fixed', bottom: 100, right: 25, cursor: 'pointer', zIndex: 10 }}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <img
                alt=""
                src={images.footer_totop}
                style={{
                  borderRadius: 6,
                  boxShadow: '0 4px 18px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1)',
                }}
              />
            </Link>
          </MediaQuery>
        )}
        {isMobile && viewGoTop && (
          <MediaQuery max={699}>
            <Link
              style={{ position: 'fixed',  bottom: 70, right: 15, cursor: 'pointer', zIndex: 10 }}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <img
                alt=""
                src={images.footer_totop}
                style={{
                  width:40,
                  borderRadius: 6,
                  boxShadow: '0 4px 18px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1)',
                }}
              />
            </Link>
          </MediaQuery>
        )}
      </ContentsWrap>
    );
  }
}

export default connect()(withTranslation()(withRouter(Footer)));
